var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-header"},[_c('div',{staticClass:"btn"},[_c('van-icon',{attrs:{"name":"bars","size":"22"},on:{"click":_vm.ClickIcon}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }